export default __webpack_public_path__ + "static/media/silvia2.257488a2.png";